import type { ThemeState } from '@atlaskit/tokens';

import { ProductKeys } from '../../constants/products';

import { getGithubOAuthSocialProofMessageContent } from './github/config';
import type { OAuthSocialProofMessageContent } from './types';

export interface GetOAuthSocialProofMessageContentParams {
	colorMode?: ThemeState['colorMode'];
}

// Only products that have a registered content builder are supported.
export type SupportedOAuthSocialProofMessageProduct = typeof ProductKeys.Github;

type ContentBuilder = (
	params: GetOAuthSocialProofMessageContentParams,
) => OAuthSocialProofMessageContent;

const contentRegistry: Record<SupportedOAuthSocialProofMessageProduct, ContentBuilder> = {
	[ProductKeys.Github]: getGithubOAuthSocialProofMessageContent,
};

/**
 * Look up the connector-specific content for a given product.
 *
 * NOTE: callers are responsible for narrowing `product` to a
 * `SupportedOAuthSocialProofMessageProduct` (i.e. only products with a
 * registered content builder).
 */
export const getOAuthSocialProofMessageContent = (
	product: SupportedOAuthSocialProofMessageProduct,
	params: GetOAuthSocialProofMessageContentParams,
): OAuthSocialProofMessageContent => contentRegistry[product](params);
